export default "__VITE_ASSET__Bwbm03uF__"